
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(\-webpack_sharing_consume_default_react\-hook\-form_react\-hook\-form\-_(7546|f1b8)|webpack_sharing_consume_default_(c(apacitor_core_capacitor_core|lsx_clsx\-webpack_sharing_consume_default_tailwind\-merge_tail\-23ec03|onnectedmotion_web\-utils_connectedmotion_web\-utils)|react\-(dom_react\-dom|oidc\-context_react\-oidc\-context)|dagrejs_dagre_dagrejs_dagre|dnd\-kit_utilities_dnd\-kit_utilities|oidc\-client\-ts_oidc\-client\-ts|orpc_client_orpc_client|xyflow_react_xyflow_react))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
